module.exports = __webpack_public_path__ + "fonts/Inter-Medium.cc6a886.woff";